export enum KnowledgeBaseAttachmentType {
    Pdf = 1,
    Excel = 2,
    Word = 3,
    Audio = 4,
    Video = 5,
    Image = 6,
    Link = 7,
    Other = 8,
    NonDownloadableVideo = 9,
    NonDownloadableAudio = 10,

}
